export function rotateImage(targetImg, degrees) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const isVertical = degrees % 180 !== 0;
        canvas.width = isVertical ? img.height : img.width;
        canvas.height = isVertical ? img.width : img.height;
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
        targetImg.src = canvas.toDataURL();
    };
    img.src = targetImg.src;
}
